import * as resaState from "../store/types/resa-state";

export const resaTradCurrentState = function (state, tids) {
	switch (state) {
		case resaState.CONFIRMED:
			if (tids !== undefined && tids.length > 0) return resaState.CONFIRMED;
			else return resaState.NEED_TABLE;
		default:
			return state;
	}
};
